import MapElement from './MapElement';
import 'ol/ol.css';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Draw, Modify, Snap } from 'ol/interaction';


export default class MapPolygonSelection extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent)
        this.source = null

        this.drawLayer()

        this.targetLayerGroup = null

        this.modifyInteraction = null
        this.drawInteraction = null
        this.snapInteraction = null

        this.createMotionplanFunction = null;
    }

    setCreateMotionplanFunction(fnc) {
        this.createMotionplanFunction = fnc
    }

    drawLayer() {
        if (!this.layer) {
            this.source = new VectorSource();
            // this.layer = new VectorLayer({
            //     source: this.source,
            //     style: new Style({
            //         stroke: new Stroke({
            //             color: '#ffcc33',
            //             width: 2,
            //         }),
            //         image: new Circle({
            //             fill: new Fill({
            //                 color: '#ffcc33'
            //             }),
            //             radius: 3,
            //         }),

            //     }),
            //     zIndex: 203
            //     // style: style
            // });

            this.layer = new VectorLayer({
                source: this.source,
                style: {
                    'fill-color': 'rgba(255, 255, 255, 0.2)',
                    'stroke-color': '#ffcc33',
                    'stroke-width': 2,
                    'circle-radius': 7,
                    'circle-fill-color': '#ffcc33',
                },
            });
            this.mapModel.map.addLayer(this.layer);
        }
        this.source.clear();

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }
    }

    setSelectState(state) {
        if (state) {
            this.addInteractions()
        } else {
            this.clearInteractions()
        }
    }

    addInteractions() {
        this.modifyInteraction = new Modify({ source: this.source });
        this.mapModel.map.addInteraction(this.modifyInteraction);

        this.drawInteraction = new Draw({
            source: this.source,
            type: "Polygon",
        });

        this.mapModel.map.addInteraction(this.drawInteraction);
        this.snapInteraction = new Snap({ source: this.source });
        this.mapModel.map.addInteraction(this.snapInteraction);

        this.drawInteraction.addEventListener("drawend", (event) => {
            console.log("feature has been drawn")

            // Get drawn polygon
            const polygonFeature = event.feature;
            const polygonGeom = polygonFeature.getGeometry();

            // Select features under the drawn polygon
            this.selectFeaturesUnderPolygon(polygonGeom);

        });
    }

    selectFeaturesUnderPolygon(polygonGeom) {
        console.log(this.targetLayerGroup)
        // const targetLayer = this.getTargetLayer(); // Get the layer where features exist
        // if (!targetLayer) 
        const selectedFeatures = [];


        this.targetLayerGroup.getLayers().forEach(layer => {
            const targetSource = layer.getSource();

            targetSource.forEachFeature((feature) => {
                const featureGeom = feature.getGeometry();
                const featureCoords = featureGeom.getCoordinates();

                const allInside = featureCoords.every(coord => polygonGeom.intersectsCoordinate(coord))

                if (allInside & feature.get('dxfData')?.type != 'POINT') {
                    selectedFeatures.push(feature);
                }
            });

            if (selectedFeatures.length > 0) {
                console.log("Selected features:", selectedFeatures);
                // this.highlightSelectedFeatures(selectedFeatures);
            }
        })
        
        if (this.createMotionplanFunction != null)
            this.createMotionplanFunction(selectedFeatures)
    }

    setTargetLayer(targetLayerGroup) {
        this.targetLayerGroup = targetLayerGroup
    }

    clearInteractions() {
        this.mapModel.map.removeInteraction(this.modifyInteraction);
        this.mapModel.map.removeInteraction(this.drawInteraction);
        this.mapModel.map.removeInteraction(this.snapInteraction);
        this.source.clear()
    }
}